import { generateStyleModifiers } from '@/utils/generateStyleModifiers';

/**
 * Function to add a 'theme' property to a Component
 *
 * @param {object} props Component props
 * @param {any} Component Component for theme integration
 * @returns {any} Component with 'theme' property added.
 */
export const themeIntegration = (Component, props) => {
    const modifiers = generateStyleModifiers(props.appliedCssClassNames);
    const theme = modifiers.theme;

    return <Component {...props} theme={theme} />;
};
